import { AfterViewInit, Component, ElementRef, inject, Inject, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { NZ_MODAL_DATA, NzModalTitleDirective, NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent } from 'ng-zorro-antd/table';
import { DatePipe } from '@angular/common';
import { LossDto } from 'src/app/shared/dto/loss.dto';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

@Component({
    selector: 'app-modal-watch-losses',
    templateUrl: './modal-watch-losses.component.html',
    styleUrls: ['./modal-watch-losses.component.scss'],
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        NzModalFooterDirective,
        NzEmptyModule,
        DatePipe,
        LoaderComponent
    ]
})
export class ModalWatchLossesComponent implements AfterViewInit{
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;

    isLoading: boolean = true;
    losses: LossDto[] = [];
    tableHeight!: number;

    private readonly modalRef = inject(NzModalRef);

    constructor(@Inject(NZ_MODAL_DATA) public data: { nzTitle: string, processId: number, losses: LossDto[] }) {
        this.losses = (data?.losses as LossDto[]) ?? [];
        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - TITLE_TABLE_SIZE;
        });
    }

    handleCancel(): void {
        this.modalRef.close();
    }
}
